import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

import { useDynamicComponent } from '@/composables/dynamic-component'
import { getTemplateData, scrollToTop, scrollToSelector, scrollIntoView, setHash } from '@/utils'

import type { Locale, ThemeSettings } from '@/types'
import type { Product } from '@/types/shopify'

export const useThemeStore = defineStore('theme', () => {

  const locale = (document.querySelector('html')?.getAttribute('lang') || 'en') as Locale
  const settings = getTemplateData<ThemeSettings>('#json-theme-settings')
  const blenderBottleProduct = ref(getTemplateData<Product>('#json-shaker-bottle'))

  const sheet = useDynamicComponent()
  const modal = useDynamicComponent()

  const menu = ref<string>()
  const menuShow = (key: string) => {
    menu.value = key
    document.documentElement.classList.add('overflow-hidden')
    document.body.classList.add('overflow-hidden')
  }
  const menuHide = () => {
    menu.value = undefined
    document.documentElement.classList.remove('overflow-hidden')
    document.body.classList.remove('overflow-hidden')
  }


  const isInPDPorPLP = computed(() => window.location.pathname.startsWith('/products'))

  return {
    locale,
    settings,
    menu,
    menuShow,
    menuHide,
    sheet,
    modal,
    blenderBottleProduct,
    isInPDPorPLP,
    setHash,
    scrollToSelector,
    scrollToTop,
    scrollIntoView
  }
})
